let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("b5AzK")).then(() => parcelRequire('b0htF'));